import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getYonghuiCategory, getYonghuiChannelCategory, setYonghuiChannelCategory } from '../api';
export default {
  name: 'CakeStoreBlacklistDrawer',
  props: {
    mode: {
      type: String,
      default: '个性化规则' // '默认规则' | '个性化规则'
    }
  },
  data: function data() {
    return {
      visible: false,
      item: null,
      isEdit: false,
      customerId: '',
      customerAccountId: '',
      saveLoading: false,
      // 树相关
      filterText: '',
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
      checkedKeys: [],
      // 暂存的三级末级 ID 集合（用于关键词过滤场景下精确控制选中项）
      stashedLeafIds: [],
      // 防止 setCheckedKeys 触发 handleCheck 循环
      isAutoSyncing: false,
      expandLoading: false,
      expandedKeys: [],
      // 已选路径分页
      pathCurrentPage: 1,
      pathPageSize: 20
    };
  },
  computed: {
    // 已勾选的路径列表（基于暂存集合，不受关键词过滤影响）
    checkedPaths: function checkedPaths() {
      return this.buildStashedPaths(this.treeData, []).filter(function (item) {
        return item.split('>').length === 3;
      }).map(function (item) {
        return {
          fullPath: item
        };
      });
    },
    // 分页后的已选路径
    pagedCheckedPaths: function pagedCheckedPaths() {
      var start = (this.pathCurrentPage - 1) * this.pathPageSize;
      return this.checkedPaths.slice(start, start + this.pathPageSize);
    },
    // 已勾选的叶子节点数（暂存集合总量，不受关键词过滤影响）
    checkedLeafCount: function checkedLeafCount() {
      return this.stashedLeafIds.length;
    },
    // 已勾选的末级 id（仅三级路径的叶子节点，基于暂存集合）
    checkedLeafIds: function checkedLeafIds() {
      return this.stashedLeafIds;
    },
    // 覆盖的一级分类数（基于暂存集合，不受关键词过滤影响）
    checkedTopLevelCount: function checkedTopLevelCount() {
      return new Set(this.buildStashedPaths(this.treeData, []).filter(function (item) {
        return item.split('>').length === 3;
      }).map(function (item) {
        return item.split('>')[0];
      })).size;
    },
    // 是否全部展开
    isAllExpanded: function isAllExpanded() {
      var allKeys = this.getAllKeys(this.treeData);
      return allKeys.length > 0 && this.expandedKeys.length === allKeys.length;
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    // 暂存选中：将当前 el-tree 勾选的三级末级 ID 合并到暂存集合
    // 有关键词时只暂存匹配关键词的末级，无关键词时暂存全部勾选末级
    stashChecked: function stashChecked() {
      var _this = this;
      var allCheckedLeaves = this.getCurrentLeafIds();
      var toStash = allCheckedLeaves;
      if (this.filterText) {
        // 有关键词时，只暂存末级名称匹配关键词的
        toStash = allCheckedLeaves.filter(function (id) {
          var node = _this.findNodeById(_this.treeData, id);
          return node && node.name.includes(_this.filterText);
        });
      }
      // 合并去重
      var merged = new Set([].concat(_toConsumableArray(this.stashedLeafIds), _toConsumableArray(toStash)));
      this.stashedLeafIds = _toConsumableArray(merged);
      // 同步树的勾选状态与暂存集合一致
      this.$nextTick(function () {
        _this.$refs.tree && _this.$refs.tree.setCheckedKeys(_this.stashedLeafIds);
        _this.checkedKeys = _toConsumableArray(_this.stashedLeafIds);
      });
      // this.$message.success(`已暂存 ${toStash.length} 个末级分类，累计共 ${this.stashedLeafIds.length} 个`)
      this.pathCurrentPage = 1;
    },
    // 获取当前 el-tree 实时勾选的三级末级 ID
    // 非 check-strictly 模式下 checkedKeys 只含叶子节点 ID
    getCurrentLeafIds: function getCurrentLeafIds() {
      var _this2 = this;
      var _pickLeaves = function pickLeaves(nodes) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var ids = [];
        nodes.forEach(function (node) {
          if (node.children && node.children.length > 0) {
            ids = ids.concat(_pickLeaves(node.children, depth + 1));
          } else if (depth === 2 && _this2.checkedKeys.includes(node.id)) {
            ids.push(node.id);
          }
        });
        return ids;
      };
      return _pickLeaves(this.treeData);
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.resetCheck();
      this.filterText = '';
      this.item = null;
      this.stashedLeafIds = [];
    },
    handleSave: function handleSave() {
      var _this3 = this;
      this.saveLoading = true;
      var leafKeys = this.stashedLeafIds;
      var params = {
        params: JSON.stringify({
          small_category_arr: leafKeys
        })
      };
      if (this.mode.includes('个性化规则')) {
        params.customer_id = this.customerId, params.customer_account_id = this.customerAccountId;
        params.blacklist_rule_type = 1;
      } else {
        params.blacklist_rule_type = 0;
      }
      setYonghuiChannelCategory(params).then(function (res) {
        _this3.$message.success('黑名单规则保存成功');
        _this3.$emit('save-success', leafKeys.length);
        _this3.handleClose();
      }).catch(function () {
        _this3.$message.error('保存失败，请稍后重试');
      }).finally(function () {
        _this3.saveLoading = false;
      });
    },
    // 获取仅三级末级分类的勾选ID（基于暂存集合，不再受关键词过滤影响保存数据）
    getLeafKeys: function getLeafKeys() {
      return this.stashedLeafIds;
    },
    // 根据ID查找节点
    findNodeById: function findNodeById(nodes, id) {
      var _iterator = _createForOfIteratorHelper(nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          if (node.id === id) return node;
          if (node.children && node.children.length > 0) {
            var found = this.findNodeById(node.children, id);
            if (found) return found;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    },
    // 树节点过滤
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 勾选变化时自动暂存：有关键词只同步匹配项，无关键词同步全部
    handleCheck: function handleCheck(data, _ref) {
      var _this4 = this;
      var checkedKeys = _ref.checkedKeys;
      if (this.isAutoSyncing) return; // 防止 setCheckedKeys 触发循环
      this.checkedKeys = checkedKeys;
      var currentCheckedLeaves = this.getCurrentLeafIds();
      if (this.filterText) {
        // 有关键词：只同步匹配关键词的末级（增/删），非匹配的保持原样
        var matchedIds = currentCheckedLeaves.filter(function (id) {
          var node = _this4.findNodeById(_this4.treeData, id);
          return node && node.name.includes(_this4.filterText);
        });
        // 保留暂存中不匹配当前关键词的项，替换匹配项为当前勾选状态
        var nonMatchedStash = this.stashedLeafIds.filter(function (id) {
          var node = _this4.findNodeById(_this4.treeData, id);
          return !node || !node.name.includes(_this4.filterText);
        });
        this.stashedLeafIds = _toConsumableArray(new Set([].concat(_toConsumableArray(nonMatchedStash), _toConsumableArray(matchedIds))));
      } else {
        // 无关键词：暂存集合 = 当前全部勾选的末级
        this.stashedLeafIds = currentCheckedLeaves;
      }

      // 同步树的勾选状态与暂存集合一致
      this.$nextTick(function () {
        _this4.isAutoSyncing = true;
        if (_this4.$refs.tree) {
          _this4.$refs.tree.setCheckedKeys(_this4.stashedLeafIds);
          _this4.checkedKeys = _toConsumableArray(_this4.stashedLeafIds);
        }
        _this4.isAutoSyncing = false;
      });
      this.pathCurrentPage = 1;
    },
    // 展开/折叠全部
    toggleExpandAll: function toggleExpandAll() {
      var _this5 = this;
      var allKeys = this.getAllKeys(this.treeData);
      var expand = !this.isAllExpanded;
      this.expandedKeys = expand ? allKeys : [];
      setTimeout(function () {
        allKeys.forEach(function (key) {
          var node = _this5.$refs.tree.getNode(key);
          if (node) node.expanded = expand;
        });
      }, 0);
    },
    // 节点展开
    handleNodeExpand: function handleNodeExpand(data) {
      if (!this.expandedKeys.includes(data.id)) {
        this.expandedKeys.push(data.id);
      }
    },
    // 节点折叠
    handleNodeCollapse: function handleNodeCollapse(data) {
      var idx = this.expandedKeys.indexOf(data.id);
      if (idx > -1) {
        this.expandedKeys.splice(idx, 1);
      }
    },
    // 重置勾选
    resetCheck: function resetCheck() {
      this.checkedKeys = [];
      this.stashedLeafIds = [];
      this.pathCurrentPage = 1;
      this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
    },
    // 路径分页切换
    handlePathPageChange: function handlePathPageChange(page) {
      this.pathCurrentPage = page;
    },
    // 路径每页条数切换
    handlePathSizeChange: function handlePathSizeChange(size) {
      this.pathPageSize = size;
      this.pathCurrentPage = 1;
    },
    // 获取所有节点的 key
    getAllKeys: function getAllKeys(nodes) {
      var _this6 = this;
      var keys = [];
      nodes.forEach(function (node) {
        keys.push(node.id);
        if (node.children && node.children.length > 0) {
          keys = keys.concat(_this6.getAllKeys(node.children));
        }
      });
      return keys;
    },
    // 构建暂存集合的路径（基于 stashedLeafIds）
    buildStashedPaths: function buildStashedPaths(nodes, parentPath) {
      var _this7 = this;
      var paths = [];
      nodes.forEach(function (node) {
        var currentPath = parentPath.concat(node.name).join('>');
        if (_this7.stashedLeafIds.includes(node.id)) {
          paths.push(currentPath);
        }
        if (node.children && node.children.length > 0) {
          paths = paths.concat(_this7.buildStashedPaths(node.children, parentPath.concat(node.name)));
        }
      });
      return paths;
    },
    // 格式化分类数据（字段映射）
    formatCategoryData: function formatCategoryData(nodes) {
      var _this8 = this;
      return nodes.map(function (node) {
        var item = {
          id: node.small_category,
          name: node.small_category_name,
          children: []
        };
        if (node.children && node.children.length > 0) {
          item.children = _this8.formatCategoryData(node.children);
        }
        return item;
      });
    },
    // 加载分类树数据
    loadCategoryList: function loadCategoryList() {
      var _this9 = this;
      var params = null;
      if (this.mode.includes('个性化规则')) {
        params = {
          customer_id: this.customerId,
          customer_account_id: this.customerAccountId
        };
      }
      Promise.all([getYonghuiCategory(), getYonghuiChannelCategory(params ? params : '')]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          categoryRes = _ref3[0],
          channelRes = _ref3[1];
        _this9.treeData = _this9.formatCategoryData(categoryRes.data);
        var checkedData = channelRes.data.small_category_arr;
        _this9.checkedKeys = Array.isArray(checkedData) ? checkedData : [];
        // 初始化暂存集合
        _this9.stashedLeafIds = _toConsumableArray(_this9.checkedKeys);
        _this9.$nextTick(function () {
          _this9.$refs.tree && _this9.$refs.tree.setCheckedKeys(_this9.checkedKeys);
        });
        _this9.pathCurrentPage = 1;
      }).catch(function () {
        _this9.$message.error('加载分类数据失败');
      });
    }
  }
};